import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onBookService }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
              <Icon name="Award" size={16} />
              <span>Certifié et assuré</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
              Votre expert en plomberie
              <span className="text-primary block mt-2">disponible 24/7</span>
            </h1>
            
            <p className="text-lg lg:text-xl text-muted-foreground mb-8 max-w-2xl">
              Interventions rapides, devis transparents, techniciens certifiés. 
              Réservez votre service en quelques clics et suivez votre intervention en temps réel.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="default"
                size="xl"
                iconName="Calendar"
                onClick={onBookService}
                className="shadow-lg"
              >
                Réserver un service
              </Button>
              <Button
                variant="outline"
                size="xl"
                iconName="Phone"
                onClick={() => window.location.href = 'tel:+33123456789'}
              >
                Urgence : 01 23 45 67 89
              </Button>
            </div>
            
            <div className="mt-8 flex flex-wrap gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="CheckCircle2" size={20} className="text-success" />
                <span>Intervention sous 2h</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="CheckCircle2" size={20} className="text-success" />
                <span>Devis gratuit</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="CheckCircle2" size={20} className="text-success" />
                <span>Garantie 6 mois</span>
              </div>
            </div>
          </div>
          
          <div className="relative hidden lg:block">
            <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <Icon name="Wrench" size={120} className="text-primary/30 mb-4" />
                  <p className="text-muted-foreground">Image professionnelle de plomberie</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -bottom-6 -right-6 bg-card rounded-xl shadow-lg p-4 border border-border">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
                  <Icon name="Star" size={24} className="text-success" />
                </div>
                <div>
                  <div className="font-semibold text-foreground">4.9/5</div>
                  <div className="text-sm text-muted-foreground">+2,500 avis clients</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;